import { flatten } from "flat";
import fp from "lodash/fp";
import { useStore } from "react-redux";
import { getFormAsyncErrors, getFormSyncErrors, touch } from "redux-form";

export const useCollectTabError = () => {
	const store = useStore();
	const dispatch = store.dispatch;

	const collectTabError = (formName, tabName) => {
		const state = store.getState();

		const syncErrors = getFormSyncErrors(formName)(state);
		const fieldsWithError = Object.keys(flatten(syncErrors));
		dispatch(touch(formName, ...fieldsWithError));

		const asyncErrors = getFormAsyncErrors(formName)(state);

		const isVisibleError = error =>
			// Additional case to check fee range error
			error?.hasOwnProperty("isInvalidRangeValue")
				? error.isInvalidRangeValue
				: error;

		const errors = Object.values({
			...syncErrors,
			...asyncErrors,
		})?.filter(isVisibleError);

		if (!fp.isEmpty(errors)) {
			return tabName
				? `Validation error. Tab: ${tabName}`
				: `Validation error`;
		}
	};

	return collectTabError;
};

export const useCollectAllTabErrors = () => {
	const collectTabError = useCollectTabError();

	const collectAllTabErrors = errorSelectors =>
		Promise.all(
			errorSelectors.map(async validate => {
				if (typeof validate === "string") {
					return validate;
				}
				return typeof validate === "function"
					? validate?.then
						? await validate()
						: validate()
					: collectTabError(...validate);
			}),
		);

	return collectAllTabErrors;
};
